import { CinemaShowtimeLocation } from '@components/molecules/CinemaShowtimeLocation/CinemaShowtimeLocation';
import type { GetMovieShowtimesUpcomingQuery } from '@lib/graphql/generated';
import { useEffect, useState } from 'react';

export interface CinemaShowtimesProps {
  showtimes: GetMovieShowtimesUpcomingQuery['movie']['showtimesUpcoming']['data'];
  cinema?: string;
  state?: string;
  noFilter?: boolean;
}

export const CinemaShowtimes = ({ showtimes, cinema, state, noFilter }: CinemaShowtimesProps) => {
  const [filteredShowtimes, setFilteredShowtimes] = useState({ data: [] });

  useEffect(() => {
    setFilteredShowtimes(() => {
      const data = noFilter
        ? showtimes
        : showtimes
            ?.filter((e) => !!e.cinema?.id)
            .filter((item) => {
              if (state && item.cinema.city.state_code !== state) {
                return false;
              }

              if (cinema && item.cinema.id !== cinema) {
                return false;
              }

              return true;
            });

      const groupedData = data.reduce((hash, obj) => {
        const key = obj.cinema?.id;
        hash[key] = (hash[key] || []).concat(obj);
        return hash;
      }, {});
      return { data: Object.values(groupedData) };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showtimes, cinema, noFilter, state]);

  return (
    <>
      {filteredShowtimes?.data?.length > 0 && (
        <div className="grid gap-y-2">
          {filteredShowtimes.data.map((showtimesLocation, index) => (
            <CinemaShowtimeLocation key={index} showtimes={showtimesLocation} />
          ))}
        </div>
      )}
    </>
  );
};
